var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewNotif(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2952 17.5C8.88281 18.0187 9.65468 18.3334 10.5001 18.3334C11.3454 18.3334 12.1173 18.0187 12.7049 17.5M15.5001 6.66669C15.5001 5.3406 14.9733 4.06884 14.0356 3.13115C13.0979 2.19347 11.8261 1.66669 10.5001 1.66669C9.17397 1.66669 7.9022 2.19347 6.96452 3.13115C6.02684 4.06884 5.50006 5.3406 5.50006 6.66669C5.50006 9.24184 4.85045 11.005 4.12478 12.1712C3.51266 13.1549 3.2066 13.6468 3.21783 13.784C3.23025 13.9359 3.26244 13.9939 3.38487 14.0847C3.49544 14.1667 3.99388 14.1667 4.99077 14.1667H16.0093C17.0062 14.1667 17.5047 14.1667 17.6152 14.0847C17.7377 13.9939 17.7699 13.9359 17.7823 13.784C17.7935 13.6468 17.4875 13.1549 16.8753 12.1712C16.1497 11.005 15.5001 9.24184 15.5001 6.66669Z",
    stroke: "#F9FAFB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNotif);
export default __webpack_public_path__ + "static/media/NewNotif.44bec8b44bbfd542b3aacab7cc4ceb4c.svg";
export { ForwardRef as ReactComponent };